import type { FC } from 'react'
import styled from '@emotion/styled'

import Badge from '@segment/matcha/components/Badge'
import ButtonText from '@segment/matcha/components/ButtonText'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CardBase, * as CardRecipe from '@segment/matcha/recipes/Card'

import type { Resource } from '@segment/api/types/resource'

const Card: FC<Omit<Resource, `featured`>> = ({ url, image, label, tags, title, description, cta }) => {
  return (
    <CardBase href={url}>
      {image && <StyledImage alt={image.title} src={image.src} variant="fill" />}
      <CardRecipe.Body>
        <CardRecipe.Accessories>
          {label && (
            <CardRecipe.AccessoriesRow>
              <CardRecipe.Label>{label}</CardRecipe.Label>
            </CardRecipe.AccessoriesRow>
          )}

          {Boolean(tags?.length) && (
            <CardRecipe.AccessoriesRow>
              {tags?.map((tag, key) => (
                <Badge key={key} variant="outlined">
                  {tag}
                </Badge>
              ))}
            </CardRecipe.AccessoriesRow>
          )}
        </CardRecipe.Accessories>
        <CardRecipe.Copy>
          <CardRecipe.Headline tag="h3">{title}</CardRecipe.Headline>
          <CardRecipe.Description>{description}</CardRecipe.Description>
        </CardRecipe.Copy>
        {cta && (
          <CardRecipe.Action alignment="left">
            <ButtonText iconEnd={ChevronRightIcon}>{cta}</ButtonText>
          </CardRecipe.Action>
        )}
      </CardRecipe.Body>
    </CardBase>
  )
}

const StyledImage = styled(CardRecipe.Image)`
  height: 170px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    height: 209px;
  }
`

export default Card
